import type { AttendanceState, TimesheetResponse } from '@wf/shared'
import { formatHMS } from '../time/format'
import { liveWorkedSeconds, useNow } from './live'

/**
 * Karte „Gearbeitet heute" (Design 1a): großer Live-Zähler (server-persistiertes liveSince), SVG-
 * Fortschrittsbalken zum Tagessoll (Dienstplan; ohne Solltag → Balken versteckt) und die ehrliche
 * Fußzeile: Tagessoll + SALDO DIESE WOCHE aus dem Timesheet. (Das kumulierte Überstundenkonto aus dem
 * Design braucht eine eigene Backend-Welle — bis dahin zeigen wir nichts Erfundenes.)
 */
export function WorkedTodayCard({ state, sollTodaySeconds, weekTimesheet }: {
  state: AttendanceState
  sollTodaySeconds: number | null
  weekTimesheet: TimesheetResponse | undefined
}) {
  const now = useNow(state.liveSince != null)
  const worked = liveWorkedSeconds(state, now)
  const pct = sollTodaySeconds && sollTodaySeconds > 0 ? Math.min(100, (worked / sollTodaySeconds) * 100) : null
  const saldo = weekTimesheet ? weekTimesheet.totalIstSeconds - weekTimesheet.totalSollSeconds : null
  const saldoText = saldo == null ? null : `${saldo < 0 ? '−' : '+'}${formatHMS(Math.abs(saldo))}`

  return (
    <div className="wf-card wf-zscard wf-zscard--center">
      <div className="wf-zscard__label">Gearbeitet heute</div>
      <div className="wf-zscard__big wf-mono" role="timer" aria-label="Arbeitszeit heute">
        {formatHMS(worked)}
      </div>
      {pct != null ? (
        <svg className="wf-zsprog" width="100%" height="8" aria-hidden="true">
          <rect className="wf-zsprog__track" x="0" y="0" width="100%" height="8" rx="4" />
          <rect className="wf-zsprog__fill" x="0" y="0" width={`${pct}%`} height="8" rx="4" />
        </svg>
      ) : null}
      <div className="wf-zscard__foot">
        <span>{sollTodaySeconds != null ? `Soll heute: ${formatHMS(sollTodaySeconds)}` : 'Kein Solltag (Dienstplan leer)'}</span>
        {saldoText != null ? (
          <span>
            Saldo diese Woche:{' '}
            <span className={saldo == null || saldo === 0 ? '' : saldo < 0 ? 'wf-ztweek__diff--minus' : 'wf-ztweek__diff--plus'}>
              {saldo === 0 ? '±00:00:00' : saldoText}
            </span>
          </span>
        ) : null}
      </div>
    </div>
  )
}
